import c from './Landing.module.css';

export function Footer() {
  return (
    <footer className={c.footer}>
      <div className={`${c.container} ${c.footerInner}`}>
        <span className={c.footerBrand}>
          <span className={`${c.mark} ${c.markSm}`}><img className={c.logoImg} src="/logo.png" alt="eXonstech" /></span>
          © {new Date().getFullYear()} eXonstech · Toronto, ON
        </span>
        <span>AI · CLOUD · WEB · MOBILE — BUILT WITH AGENTS</span>
      </div>
    </footer>
  );
}
